import { fetchUtils } from 'react-admin';
import { turnAPI } from '@/providers/turn/dataProvider';
import { HttpClient } from './types';

const httpClient: HttpClient = (url, options = {}) => {
  options.user = {
    authenticated: true,
    token: `Bearer ${localStorage.getItem('access_token')}`,
  };
  return fetchUtils.fetchJson(url, options);
};

export default turnAPI(httpClient);
